module.exports = {
  placeholderInput: 'Please input',
  placeholderSelect: 'Please select',
  productCode: 'Product Code',
  productName: 'Product Name',
  productSize: 'Size',
  sendStatus: 'Send Status',
  taggingTime: 'Tagging Time',
  search: 'Run',
  clear: 'Clear',
  status: 'Status',
  total: 'Total',
  success: 'Operation successful',
  errorTitle: 'Error',
  infoTitle: 'Info',
  successTitle: 'Success',
  warningTitle: 'Warning',
  confirmTitle: 'Confirm',
  tagSuccess: 'Tag Success',
  products: 'Products',
  resendFailed: 'resend failed',
  sendTime: 'Send Time',
  workStation: 'Work Station',
  operator: 'Operator',
  sendFail: 'Send Fail',
  sendSuccess: 'Send Success',
  sendTotal: 'Total Send Lines',
  resend: 'Resend',
  isRequired: ' is required.',
  delete: 'Delete',
  addNew: 'Add New',
  edit: 'Edit',
  all: 'ALL',
  last7: 'Last 7 Days',
  last30: 'Last 30 Days',
  last90: 'Last 90 Days',
  download: 'Download',
  downloadError: '获取文件失败',
  error404: 'The page you visited does not exist.',
  errorAuth: 'Sorry!',
  placeholderFormat: '格式：\nXXXXXX\nXXXXXX'
}
